import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertComponent } from 'src/app/alert/alert.component';
import { DetailHargaComponent } from 'src/app/detail-harga/detail-harga.component';
import { ProposalService } from 'src/app/services/proposal.service';

declare var $: any;

@Component({
  selector: 'app-detail-proposal',
  templateUrl: './detail-proposal.component.html',
  styleUrls: ['./detail-proposal.component.css']
})
export class DetailProposalComponent implements OnInit {
  proposal: any;
  detailProductList = [];
  productNameList = [];
  productName: string;
  isEmpty: boolean;
  searchProduct = "";
  isLoading = true;
  file: File;
  fileName = '';
  fileSize = 0;
  alertFileSize = '';
  submitted = false;
  SPNumber = '';
  reason = '';
  alertFileFormat = '';
  errorMessageSAP = '';

  @ViewChild('alertComponent') alertComponent: AlertComponent;
  @ViewChild('detailHargaComponent') detailHargaComponent: DetailHargaComponent;

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    const width = event.target.innerWidth;
    this.webResponsive(width);
  }

  constructor(
    public proposalService: ProposalService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    const width = window.innerWidth;
    this.webResponsive(width);
  }

  ngOnInit() {
    $('#failedModal').removeClass('d-flex align-items-center');
    this.isLoading = true;
    this.getProposalDetail();

    $('#modal-confirmation').on('hidden.bs.modal', function () {
      $(this).removeClass('d-flex align-items-center');
    });

    $('#failedModal').on('hidden.bs.modal', function () {
      $(this).removeClass('d-flex align-items-center');
    });
  }

  public getProposalDetail() {
    const id = this.route.snapshot.paramMap.get("id");

    this.proposal = this.proposalService.getProposalDetail(
      id,
      (resp) => {
        this.proposal = resp;
        this.detailProductList = this.proposal.dataOrder;
        this.isLoading = false;
        const width = window.innerWidth;
        this.initWebResponsive(width);
      },
      (err) => {
        console.log(err);
      }
    );
  }

  batal() {
    this.reason = '';
  }

  terima() {
    this.submitted = true;

    if (this.SPNumber && this.file) {
      $('#page-title').html('Terima Proposal ?');
      $('#page-title').css('color', '#094658');
      $('#info-title').html('Proposal akan langsung diproses sebagai transaksi');
      $('#btn-tolak-container').hide();
      $('#btn-terima-container').show();
      $('#reason').hide();
      $("#modal-confirmation").addClass('d-flex align-items-center');
      $("#modal-confirmation").modal("toggle");
    }
  }

  approve() {
    this.isLoading = true;

    const param = {
      NoTransaksi: this.proposal.No_Transaksi,
      CustCode: this.proposal.Customer_Code,
      Response: true,
      Reason: '',
      PurchaseOrderNumber: this.SPNumber,
      Files: this.file
    }

    this.proposalService.approvalProposal(param, (resp) => {
      this.isLoading = false;
      if (resp === 'Success') {
        this.ngOnInit();
      }
    }, (err) => {
      this.isLoading = false;
      if (err.status && err.statusText) {
        this.alertComponent.show(err.status, err.statusText);
      } else {
        // jika error sap
        this.errorMessageSAP = err.message;
        $(".failedModal").addClass('d-flex align-items-center');
        $(".failedModal").modal("toggle");
      }
    });
  }

  tolak() {
    $('#page-title').html('Tolak Proposal');
    $('#page-title').css('color', '#EB7664');
    $('#info-title').html('Apakah Anda Yakin ingin menolak Proposal?');
    $('#btn-terima-container').hide();
    $('#btn-tolak-container').show();
    $('#reason').show();
    $("#modal-confirmation").addClass('d-flex align-items-center');
    $("#modal-confirmation").modal("toggle");
  }

  reject() {
    this.isLoading = true;

    const param = {
      NoTransaksi: this.proposal.No_Transaksi,
      CustCode: this.proposal.Customer_Code,
      Response: false,
      Reason: this.reason,
      PurchaseOrderNumber: '',
      Files: this.file
    }

    this.proposalService.approvalProposal(param, (resp) => {
      this.isLoading = false;
      if (resp === 'Success') {
        this.ngOnInit();
      }
    }, (err) => {
      this.reason = '';
      this.isLoading = false;
      this.alertComponent.show(err.status, err.statusText);
    });
  }

  onFileChanged(files: FileList): void {
    this.alertFileFormat = '';
    const ext = files[0].type;

    if (ext !== 'application/pdf' && ext !== 'image/jpeg' && ext !== 'image/jpg' && ext !== 'image/png'
      && ext !== 'image/png' && ext !== 'text/plain' && ext !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      && ext !== 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
      this.alertFileFormat = 'Format yang diperbolehkan png, jpg, jpeg, pdf, txt, doc, docx, xls, xlsx';
      this.file = null;
      this.fileName = '';
      this.fileSize = 0;
      $('#sp-container').css('margin-top', '-40px');
      return;
    }

    $('#sp-container').removeAttr('style');

    this.fileName = '';
    this.fileSize = 0;

    if (files.length > 0) {
      const file = files.item(0);
      const file_size = file.size / 1024 / 1024;

      if (file_size <= 25) {
        this.alertFileSize = '';
        this.fileName = file.name;
        this.fileSize = file_size;
        this.file = file;
      } else {
        this.alertFileSize = 'Ukuran file maksimal 25MB';
        this.file = undefined;
      }
    } else {
      this.file = undefined;
    }

    if (this.fileName) {
      $('#sp-container').removeClass('ringkasan-fixed-top');
      $('#sp-container').addClass('ringkasan-fixed-top-2');
    }
  }

  getMyStatus(status: number) {
    switch (status) {
      case 1:
        return { name: 'Diterima', color: '#719849' };
      case 2:
        return { name: 'Ditolak', color: '#EB7664' };
      case 3:
        return { name: 'Sudah Lewat', color: '#4D4D4D' };
    }
  }

  lihatTransaksi() {
    this.router.navigate(['/transaction'], {
      queryParams: {
        tab: 'created'
      }
    })
  }

  detailHarga() {
    this.detailHargaComponent.show(this.proposal.Total_Sebelum_Diskon, this.proposal.Total_Diskon, [], this.proposal.pajak, this.proposal.Grand_Total, this.proposal.Total_Harga_Setelah_Diskon, this.proposal.materai);
  }

  initWebResponsive(width) {
    $(document).ready(function () {
      $('.sidebar').hide();
      $('#sp-container').addClass('ringkasan-fixed-top');
      $('#main-panel').addClass('main-panel-full');
      $('#main-panel').removeClass('main-panel');

      $('.navbar-toggler-icon').click(() => {
        $('.sidebar').show();
        $('#main-panel').removeClass('main-panel-full');
        $('#main-panel').addClass('main-panel');
      });

      if (width < 992) {
        $('#sp-container').removeClass('ringkasan-fixed-top');
        $('#sp-container').removeClass('ringkasan-fixed-top-2');
      }
    });
  }

  webResponsive(width) {
    if (width < 992) {
      $('#sp-container').removeClass('ringkasan-fixed-top');
      $('#sp-container').removeClass('ringkasan-fixed-top-2');

      $('.sidebar').show();

      $('#main-panel').removeClass('main-panel-full');
      $('#main-panel').addClass('main-panel');
    } else {
      $('.sidebar').hide();
      $('#main-panel').addClass('main-panel-full');
      $('#main-panel').removeClass('main-panel');

      if (this.fileName) {
        $('#sp-container').removeClass('ringkasan-fixed-top');
        $('#sp-container').addClass('ringkasan-fixed-top-2');
      } else {
        $('#sp-container').addClass('ringkasan-fixed-top');
      }
    }

    $('.navbar-toggler-icon').click(() => {
      $('.sidebar').show();
      $('#main-panel').removeClass('main-panel-full');
      $('#main-panel').addClass('main-panel');
    });
  }
}
